<template>
    <product-gallery
        class="post-production-gallery"
        :unordered-slides="sectionGallery.productGallery"
        :products="sectionGallery.products"
        :swipe-instructions="sectionGallery.gallerySwipeInstructions"
        :default-product="sectionGallery.defaultProduct"
    >
        <template v-slot:product-selection="{products, currentProductSlug, onProductChange}">
            <div
                class="product-controls flex flex-grow px-4 absolute top-10 z-40 phone:justify-between tablet:top-8 tablet:left-8 tablet:flex-col tablet:mr-10 tabletLandscape:absolute tablet:left-6 desktop:left-12 hd:left-24">
                <product-controls
                    class="phone:w-1/2 phone:mx-4"
                    :products="products"
                    :category-label="sectionGallery.categoryLabel"
                    :category-slug="sectionGallery.categorySlug"
                    :current-product-slug="currentProductSlug"
                    :on-product-change="onProductChange"
                />
            </div>
        </template>

        <template v-slot:product-description="{products, currentProductSlug}">
            <photo-gallery-product-descriptions
                :products="products"
                :current-product-slug="currentProductSlug"
            />
        </template>
    </product-gallery>
</template>

<script>
import ProductGallery from '@web/components/ProductGalleries/ProductGallery';
import ProductControls from '@web/components/ProductGalleries/controls/ProductControls';
import PhotoGalleryProductDescriptions from '@web/pages/sections/PostProductionPage/PhotoGalleryProductDescriptions';

export default {
  components: {
    PhotoGalleryProductDescriptions,
    ProductGallery,
    ProductControls,
  },
  props: {
    sectionGallery: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
</style>
